import { api } from '../redux/api/axiosManager';

const API_BASE_URL = '/api/admin/dashboard';

/**
 * Backend bazen totalCount, bazen total / count / totalItems döndürür; tek forma getirir.
 * Son sayfadaysak ve toplam yoksa: (totalPages - 1) * limit + satır sayısı ile tahmin edilir.
 */
export function normalizeRatingsPagination(raw = {}, { page: fallbackPage = 1, limit: fallbackLimit = 20, dataLength = 0 } = {}) {
  const p = raw || {};
  const limit = p.limit ?? fallbackLimit;
  const page = p.page ?? fallbackPage;

  const pickTotal = () => {
    const v = p.totalCount ?? p.total ?? p.count ?? p.totalItems;
    if (typeof v === 'number' && !Number.isNaN(v)) return v;
    if (v != null && v !== '' && !Number.isNaN(Number(v))) return Number(v);
    return undefined;
  };

  let totalCount = pickTotal();
  let totalPages = p.totalPages;

  if (totalPages == null && typeof totalCount === 'number' && totalCount >= 0 && limit > 0) {
    totalPages = Math.max(1, Math.ceil(totalCount / limit));
  }

  totalPages = totalPages ?? 0;

  if (totalCount == null && totalPages > 0 && limit > 0 && page === totalPages && dataLength > 0) {
    totalCount = (totalPages - 1) * limit + dataLength;
  }

  if (totalCount == null || Number.isNaN(totalCount)) {
    totalCount = 0;
  }

  const hasNextPage = p.hasNextPage ?? (totalPages > 0 ? page < totalPages : false);
  const hasPreviousPage = p.hasPreviousPage ?? page > 1;

  return {
    page,
    limit,
    totalCount,
    totalPages,
    hasNextPage,
    hasPreviousPage,
  };
}

/**
 * Rating Service - Kullanıcı yorumlarını yönetir
 */
export const ratingService = {
  /**
   * Kullanıcı yorumlarını getir
   * @param {Object} options - Query parametreleri
   * @param {number} options.page - Sayfa numarası (default: 1)
   * @param {number} options.limit - Sayfa başına kayıt sayısı (default: 20, max: 100)
   * @returns {Promise<Object>} API response
   */
  getRatings: async (options = {}) => {
    try {
      const params = new URLSearchParams({
        page: (options.page || 1).toString(),
        limit: (options.limit || 20).toString(),
      });

      // Tarih filtresi parametreleri
      if (options.dateRange) {
        params.append('dateRange', options.dateRange);
      }
      if (options.dateFrom) {
        params.append('dateFrom', options.dateFrom);
      }
      if (options.dateTo) {
        params.append('dateTo', options.dateTo);
      }

      const response = await api.get(`${API_BASE_URL}/ratings?${params}`);
      
      if (response.data && response.data.success) {
        const list = response.data.data || [];
        const page = options.page || 1;
        const limit = options.limit || 20;
        return {
          success: true,
          data: list,
          pagination: normalizeRatingsPagination(response.data.pagination || {}, {
            page,
            limit,
            dataLength: list.length,
          }),
          message: response.data.message,
          timestamp: response.data.timestamp,
        };
      }

      return {
        success: false,
        data: [],
        pagination: {},
        error: 'Beklenmeyen response formatı',
      };
    } catch (error) {
      console.error('❌ Kullanıcı yorumları çekilirken hata:', error);
      return {
        success: false,
        data: [],
        pagination: {},
        error: error.response?.data?.message || error.message || 'Yorumlar yüklenemedi',
      };
    }
  },
};

